import React from 'react';
import { Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react';
import { businessInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="text-3xl font-bold">
              <span className="text-[#FFB830]">La</span>
              <span className="text-[#7CB342]"> Piña</span>
            </div>
            <p className="text-gray-400 text-sm">
              Sabor que provoca. Jugos naturales y comida fresca preparada con amor en Pucallpa desde 2020.
            </p>
            <div className="flex space-x-3">
              <a
                href={businessInfo.socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-[#FFB830] p-2 rounded-full transition-colors duration-300"
              >
                <Facebook size={20} />
              </a>
              <a
                href={businessInfo.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-[#7CB342] p-2 rounded-full transition-colors duration-300"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#FFB830]">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('menu')}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Menú
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('ubicacion')}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Ubicación
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#7CB342]">Horarios</h3>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-400">
                <span className="font-semibold text-white">Dom - Jue:</span> 6:00 AM - 10:00 PM
              </li>
              <li className="text-gray-400">
                <span className="font-semibold text-white">Viernes:</span> 6:00 AM - 5:00 PM
              </li>
              <li className="text-gray-400">
                <span className="font-semibold text-red-400">Sábado:</span> Cerrado
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#FFB830]">Contacto</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start text-gray-400">
                <MapPin size={18} className="text-[#7CB342] mr-2 mt-1 flex-shrink-0" />
                <span>{businessInfo.address}</span>
              </li>
              <li className="flex items-center text-gray-400">
                <Phone size={18} className="text-[#FFB830] mr-2 flex-shrink-0" />
                <a href={`tel:${businessInfo.phone}`} className="hover:text-white transition-colors">
                  {businessInfo.phone}
                </a>
              </li>
              <li className="flex items-center text-gray-400">
                <Mail size={18} className="text-[#7CB342] mr-2 flex-shrink-0" />
                <a href={`mailto:${businessInfo.email}`} className="hover:text-white transition-colors">
                  {businessInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} <span className="text-[#FFB830] font-semibold">La Piña</span>. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
